<script>
export default {
  components: {
    // 'render-title':
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  render: function (createElement){
    let classObj = {
      heading: true
    };

    if (this.config.attrs.textAlign){
      classObj[this.config.attrs.textAlign] = true;
    }
    return createElement(`h${this.config.attrs.level}`, {
      class: classObj
    }, this.$slots.default);
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/standard';

.heading {
  &.center {
    text-align: center;
  }

  &.right {
    text-align: right;
  }
}

h1 {
  @include font_h1_l;
}

h2 {
  @include font_h2_m;
}

h3 {
  @include font_h2_s;
}
</style>